import { render } from "./CardLocation.vue?vue&type=template&id=5fabaea5&ts=true"
import script from "./CardLocation.vue?vue&type=script&lang=ts"
export * from "./CardLocation.vue?vue&type=script&lang=ts"

import "./CardLocation.vue?vue&type=style&index=0&id=5fabaea5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__